import { useFetchProductData } from '../useFetchProductData';
import { useLoadSession } from '../../Account/hooks/useLoadSession';
// import { useLoadCart } from '../../Cart/hooks';

export const usePageLoaded = (): void => {
	useFetchProductData();
	// useLoadCart();
	useLoadSession();
};
